import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import CardFooter from "../../components/Card/CardFooter.js";
import { grayColor } from "../../assets/jss/material-dashboard-react";
import CustomInput from "../../components/CustomInput/CustomInput";
import { showWarningToast } from "../../utils/toastMessages";
import { ToastContainer } from "react-toastify";

const styles = (theme) => ({
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "0px",
    minHeight: "auto",
    fontSize: "12px",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "0px",
    textDecoration: "none",
    paddingBottom: "20px",
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "16px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0",
  },
  description: {
    marginTop: "2px",
    marginBottom: "0",
    textAlign: "justify",
  },
  rowReverseMd: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row-reverse",
    },
  },
  matrixCell: {
    margin: "2px",
    width: "6%",
    fontSize: "12px",
  },
  matrixRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    paddingBottom: "2px",
  },
  dropdown: {
    width: "100px",
    fontSize: "12px",
    margin: "2px",
    padding: "2px",
  },
  alternativeInput: {
    margin: "2px",
    width: "15%",
    fontSize: "12px",
  },
  labelTxt: {
    margin: "2px",
    padding: "4px",
    flex: "0 0 15%",
    fontSize: "12px",
  },
  criteriaInput: {
    margin: "2px",
    width: "92px",
    fontSize: "12px",
    padding: "2px",
  },
  criteriaRow: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  matrixContainer: {
    overflowX: "auto",
    paddingBottom: "5px",
  },
});

const useStyles = makeStyles(styles);

export default function AlternativesNamesForm({
  alternativesNum,
  onNext,
  onBack,
  alternativesNames,
  changeAlternativeNames,
}) {
  const classes = useStyles();

  useEffect(() => {
    if (
      alternativesNames.length === 0 ||
      alternativesNames.length != alternativesNum ||
      alternativesNames.some(
        (item) => item === null || item === undefined || item === ""
      )
    ) {
      const alternativeArray = Array(Number(alternativesNum)).fill(""); // Create an array of empty strings
      changeAlternativeNames(alternativeArray);
    }
  }, [alternativesNum]);

  const handleAlternativeNameChange = (index, event) => {
    const values = [...alternativesNames];
    values[index] = event.target.value;
    changeAlternativeNames(values);
  };

  const alternativeNamesValidation = () => {
    if (alternativesNames.includes("")) {
      showWarningToast({
        title: "Popunite nazive alternativa!",
        message: "Sve alternative moraju imati nazive.",
      });
      return false;
    }

    if (alternativesNames.length !== new Set(alternativesNames).size) {
      showWarningToast({
        title: "Isti naziv dvije ili više alternativa!",
        message: "Svi nazivi alternativa moraju biti različiti!",
      });
      return false;
    }

    return true;
  };

  function handleNext() {
    if (alternativeNamesValidation()) {
      changeAlternativeNames(alternativesNames);
      onNext();
    }
  }

  return (
    <div>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>
                Unos naziva alternativa
              </h4>
              <p className={classes.cardCategoryWhite}>Nazivi alternativa</p>
            </CardHeader>
            <CardBody>
              <ToastContainer />
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  {alternativesNames.map((value, index) => (
                    <div key={index}>
                      <CustomInput
                        labelText={`Naziv alternative ${index + 1}`}
                        id={index.toString()}
                        type="text"
                        value={value}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: value,
                          onChange: (event) =>
                            handleAlternativeNameChange(index, event),
                        }}
                      />
                    </div>
                  ))}
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button color="success" onPress={onBack}>
                Nazad
              </Button>
              <Button color="success" onPress={handleNext}>
                Unos matrice
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

